import React from "react";
import Navbar from "./components/Navbar"
import Body from "./components/Body"

function App() {
  return (
    <div className="App">
      <Navbar></Navbar>
      <Body></Body>
    </div>
  );
}

export default App;
